/**
 * Réforme de la facturation électronique : qui, quoi, et surtout quand.
 *
 * TROIS OBLIGATIONS QUE PRESQUE TOUS LES ARTICLES MÉLANGENT.
 *
 *   1. RECEVOIR ses factures sous forme électronique. Elle vise toutes les
 *      entreprises assujetties établies en France, quelle que soit leur taille,
 *      depuis le 1er septembre 2026. C'est celle qu'on découvre en retard,
 *      parce qu'elle ne dépend pas de soi mais de ses fournisseurs.
 *   2. ÉMETTRE ses factures sous forme électronique. Échelonnée : les grandes
 *      entreprises et les entreprises de taille intermédiaire depuis le 1er
 *      septembre 2026, les PME et les micro-entreprises au 1er septembre 2027.
 *   3. L'E-REPORTING, la transmission à l'administration des données des
 *      opérations qui ne passent pas par une facture électronique : ventes aux
 *      particuliers et opérations avec l'étranger. Il suit le calendrier de
 *      l'émission.
 *
 * LA FRANCHISE EN BASE NE DISPENSE DE RIEN. Un micro-entrepreneur qui ne
 * facture aucune TVA reste assujetti à la TVA au sens du code, et la réforme
 * vise les assujettis. C'est le contresens le plus répandu sur le sujet.
 *
 * Calendrier revérifié le 8 septembre 2026 sur impots.gouv.fr et sur
 * entreprendre.service-public.gouv.fr, qui concordent et le rattachent à
 * l'article 91 de la loi de finances pour 2024. Il a été reporté une fois, du
 * 1er juillet 2024 au 1er septembre 2026 : toute page qui l'affiche doit être
 * datée, et ces valeurs revérifiées avant chaque échéance.
 */

export const CALENDRIER = {
    /** Recevoir : tout le monde, à la même date. */
    reception: "2026-09-01",
    /** Émettre et transmettre : échelonné par taille d'entreprise. */
    emission: {
        grande: "2026-09-01",
        eti: "2026-09-01",
        pme: "2027-09-01",
        micro: "2027-09-01",
    },
};

/** Jours restants avant une date, négatif si elle est passée. */
export function joursAvant(date, aujourdhui) {
    const cible = new Date(`${date}T00:00:00Z`);
    const jour = new Date(aujourdhui);
    return Math.ceil(
        (Date.UTC(cible.getUTCFullYear(), cible.getUTCMonth(), cible.getUTCDate()) -
            Date.UTC(jour.getUTCFullYear(), jour.getUTCMonth(), jour.getUTCDate())) /
            86400000,
    );
}

/**
 * Ce qui s'impose à cette entreprise, et à quelle date.
 *
 * @param taille "micro", "pme", "eti" ou "grande".
 * @param clientsPros facture-t-elle des professionnels établis en France ?
 * @param clientsParticuliers vend-elle à des particuliers ?
 * @param clientsEtrangers a-t-elle des clients hors de France ?
 */
export function obligations({
    taille,
    clientsPros,
    clientsParticuliers,
    clientsEtrangers,
    aujourdhui,
}) {
    const dateEmission = CALENDRIER.emission[taille];

    const ligne = (cle, date, concerne, detail = null) => {
        const jours = joursAvant(date, aujourdhui);
        return { cle, date, concerne, jours, enVigueur: jours <= 0, detail };
    };

    return [
        // La réception ne dépend pas de la clientèle : elle vient des
        // fournisseurs, et toute entreprise en a.
        ligne("reception", CALENDRIER.reception, true),
        ligne("emission", dateEmission, clientsPros),
        ligne(
            "ereporting",
            dateEmission,
            clientsParticuliers || clientsEtrangers,
            clientsParticuliers && clientsEtrangers
                ? "les deux"
                : clientsParticuliers
                  ? "particuliers"
                  : clientsEtrangers
                    ? "etranger"
                    : null,
        ),
    ];
}
